import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HelpCenterIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.89191 16.828C3.09693 17.1407 3.15882 17.526 3.06206 17.8871L2.49959 19.9863L4.58498 19.4275C4.94859 19.3301 5.33655 19.3935 5.65017 19.6017C7.18255 20.6188 9.02005 21.2114 11 21.2114C16.3505 21.2114 20.6879 16.8739 20.6879 11.5234C20.6879 6.17294 16.3505 1.83551 11 1.83551C5.64951 1.83551 1.31207 6.17294 1.31207 11.5234C1.31207 13.4839 1.89306 15.3048 2.89191 16.828ZM1.7947 17.5475C0.659958 15.817 0 13.7474 0 11.5234C0 5.44831 4.92487 0.523438 11 0.523438C17.0751 0.523438 22 5.44831 22 11.5234C22 17.5986 17.0751 22.5234 11 22.5234C8.7541 22.5234 6.66536 21.8503 4.92457 20.6949L2.83918 21.2536C1.86356 21.5151 0.970814 20.6224 1.23223 19.6467L1.7947 17.5475Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.24853 7.29243C8.87524 7.65964 8.67319 8.13854 8.5303 8.59498C8.42206 8.94077 8.05401 9.13325 7.70824 9.025C7.36247 8.91676 7.16993 8.54872 7.27819 8.20295C7.44152 7.68127 7.7228 6.95272 8.32841 6.35704C8.95384 5.74182 9.86271 5.32807 11.1597 5.32813H11.1909L11.2221 5.3311C12.7916 5.48107 13.7775 6.21402 14.2797 7.175C14.7601 8.0943 14.7549 9.13928 14.5367 9.89372C14.1734 11.1496 13.4216 11.7433 12.7069 12.1246C12.5368 12.2154 12.3689 12.2944 12.2183 12.3644C12.2015 12.3722 12.1848 12.38 12.1684 12.3876C12.0341 12.4499 11.9173 12.5042 11.8067 12.5609C11.5567 12.6892 11.4141 12.7942 11.3259 12.9066C11.1024 13.1917 10.69 13.2417 10.4049 13.0182C10.1197 12.7946 10.0699 12.3822 10.2933 12.0971C10.5582 11.7592 10.9042 11.5493 11.2076 11.3937C11.3429 11.3241 11.4846 11.2584 11.6155 11.1977C11.6323 11.1899 11.6488 11.1822 11.6652 11.1746C11.8147 11.1052 11.9539 11.0393 12.0893 10.9671C12.5967 10.6963 13.0401 10.3451 13.2762 9.5291C13.4186 9.0372 13.4132 8.34982 13.1169 7.78269C12.8447 7.26188 12.2845 6.75867 11.1283 6.6403C10.1558 6.6466 9.5982 6.94843 9.24853 7.29243Z"
        fill="currentColor"
      />
      <path
        d="M12.0154 16.1463C12.0154 16.6521 11.6054 17.0623 11.0996 17.0623C10.5937 17.0623 10.1836 16.6521 10.1836 16.1463C10.1836 15.6405 10.5937 15.2305 11.0996 15.2305C11.6054 15.2305 12.0154 15.6405 12.0154 16.1463Z"
        fill="currentColor"
      />
    </svg>
  )
})

HelpCenterIcon.displayName = 'HelpCenterIcon'
